import {
  Gender,
  PatientStatus,
  type IPatient,
} from '@principle-theorem/principle-core/interfaces';
import { MockDocRef } from '@principle-theorem/testing';
import { type ITypesensePatientWithRef } from './typesense-patient';

export function MockTypesensePatientWithRef(
  overrides: Partial<ITypesensePatientWithRef> = {}
): ITypesensePatientWithRef {
  return {
    id: 'patient',
    name: 'Alex Example',
    searchNames: [],
    email: 'alex@example.com',
    dateOfBirth: '1990-05-17',
    gender: Gender.NotSpecified,
    status: PatientStatus.Active,
    createdAt: 0,
    tagNames: [],
    tagRefs: [],
    contactNumbers: ['0400111222'],
    searchContactNumbers: [],
    ref: MockDocRef<IPatient>(),
    brandRef: 'brands/brand',
    deleted: false,
    ...overrides,
  };
}
